import { useSelector } from 'react-redux';

import { RootState } from '../redux/rootReducer';
import { SheetDb } from '../redux/sheetDbSlice';

const useOneSheetValue = (sheetId: string | null): SheetDb | undefined => {
  const sheets = useSelector((state: RootState) => state.sheetDb).sheets;
  const value = sheetId ? sheets[sheetId] : undefined;

  return value;
}

export default useOneSheetValue;
